import React from 'react';
import ReactExport from 'react-export-excel';
import usersApi from '../api/users.api';
import { Button } from 'react-bootstrap';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends React.Component {
  constructor(props) {
    super(props);

    this.sate = {
      users: []
    };
  }

  async componentDidMount() {
    try {
      const usersArr = await usersApi.getAllForExport();
      this.setState({ users: usersArr });
    } catch (error) {
      throw error;
    }
  }

  render() {
    return (
      <ExcelFile
        filename='Корисници'
        element={<Button variant='btn mr-2 button-standard'>Експортирај</Button>}
      >
        {this.state && this.state.users != null ? (
          <ExcelSheet data={this.state.users} name='Users'>
            <ExcelColumn label='Име' value='full_name' />
            <ExcelColumn label='Адреса' value='user_address' />
            <ExcelColumn label='Телефон' value='user_phone' />
          </ExcelSheet>
        ) : null}
      </ExcelFile>
    );
  }
}
export default Download;
